export default __webpack_public_path__ + "/dist/images/company-inactive.273304ee056b733efa4efc136e644446.svg";